import axios from 'axios'
import qs from 'qs'

export const learningLevelService = ({
  getAllLearningLevelList (token) {
    return axios.get('/api/LearningLevels', {headers: {'Authorization': 'Bearer ' + token}})
  },
  createLearningLevel (token, learningLevelObj) {
    return axios.post('/api/LearningLevel/Create', learningLevelObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateLearningLevel (token, learningLevelObj) {
    var stringifiedObj = qs.stringify(learningLevelObj)
    return axios.put('/api/LearningLevel/Update', stringifiedObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteLearningLevel (token, learningLevelId) {
    return axios.delete('/api/LearningLevel?LearningLevelId=' + learningLevelId, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/learning-level-services.js